import { ErrorPanel } from './ui/index.js'
import { openFeedbackDialog } from '../feedback-events.js'

function ErrorState({ message, onRetry }) {
  const feedbackAction = (
    <button
      type="button"
      className="secondary-button"
      onClick={() => openFeedbackDialog({
        type: 'bug',
        content: message ? `加载失败：${message}` : '加载失败，请刷新或提交反馈',
      })}
    >
      提交反馈
    </button>
  )
  return <ErrorPanel message={message || '加载失败，请刷新或提交反馈'} onRetry={onRetry} action={feedbackAction} />
}

export default ErrorState
